import React, { useState, useEffect } from 'react';
import Dashboard from './pages/Dashboard';
import Debug from './pages/Debug';
import DiagnosticPage from './pages/DiagnosticPage';
import DailyReport from './pages/DailyReport';
import FDTreemap from './pages/FDTreemap';
import Login from './pages/Login';
import './index.css';
import './dashboard.css';

const AUTH_KEY = 'strategy_auth_' + btoa('naocontapraninguem!');

// Check if current URL is for daily-report
const isDailyReportPage = () => {
  const path = window.location.pathname;
  return path.includes('daily-report');
};

function App() {
  const [page, setPage] = useState<'dashboard' | 'debug' | 'diagnostic' | 'daily-report' | 'fd-treemap'>(() => {
    // Check URL on initial load
    if (isDailyReportPage()) {
      return 'daily-report';
    }
    return 'dashboard';
  });
  const [error, setError] = useState<string | null>(null);
  const [scrolled, setScrolled] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem(AUTH_KEY) === 'true';
  });

  // Detectar scroll para animar o header
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const renderPageContent = () => {
    if (page === 'dashboard') {
      return <Dashboard />;
    }

    if (page === 'debug') {
      return <Debug />;
    }

    if (page === 'diagnostic') {
      return <DiagnosticPage />;
    }

    if (page === 'daily-report') {
      return <DailyReport />;
    }

    if (page === 'fd-treemap') {
      return <FDTreemap />;
    }

    // Caso de fallback padrão (não deveria ocorrer devido à tipagem)
    return <Dashboard />;
  };

  if (!isAuthenticated) {
    return <Login onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <div className="app-container">
      <header className={`app-header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-container">
          <div className="logo-container">
            <h1 className="app-title">
              <span className="app-title-gradient">XMACNA</span>
            </h1>
          </div>
          
          <nav className="app-nav">
            <ul className="nav-menu">
              <li>
                <button
                  className={`nav-link ${page === 'dashboard' ? 'active' : ''}`}
                  onClick={() => setPage('dashboard')}
                >
                  <span className="nav-icon dashboard-icon"></span>
                  Dashboard
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${page === 'debug' ? 'active' : ''}`}
                  onClick={() => setPage('debug')}
                >
                  <span className="nav-icon debug-icon"></span>
                  Debug
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${page === 'diagnostic' ? 'active' : ''}`}
                  onClick={() => setPage('diagnostic')}
                >
                  <span className="nav-icon diagnostic-icon"></span>
                  Diagnostico
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${page === 'daily-report' ? 'active' : ''}`}
                  onClick={() => setPage('daily-report')}
                >
                  <span className="nav-icon report-icon"></span>
                  Relatorio Diario
                </button>
              </li>
              <li>
                <button
                  className={`nav-link ${page === 'fd-treemap' ? 'active' : ''}`}
                  onClick={() => setPage('fd-treemap')}
                >
                  <span className="nav-icon treemap-icon"></span>
                  Mapa de Calor
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <main className="app-content">
        {renderPageContent()}
      </main>
    </div>
  );
}

export default App;
